import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import { isEmpty } from "lodash"
import parse from "html-react-parser"
import styled from "styled-components"
import { toast } from "react-toastify"

import history from "app/history"

import Spinner from "components/common/spinner"
import PageContainer from "components/common/PageContainer"
import Button from "components/common/Button"
import FormRadio from "components/form/radio"
import FormInput from "components/form/input"
import FormDropdown from "components/form/dropdown"
import {
  fetchCourseById,
  fetchCourseVoucher,
  removeVoucher,
  applyCourseAptCoins,
  removeCoins,
  getPaymentChannels,
  getPaymentFees,
  postPayment,
} from "store/courses/action"

import {
  showResponseModal,
  closeResponseModal,
  getWalletBalance,
  getWalletTransactions,
  getUserWalletNonce,
  verifyWalletAddress,
} from "store/user/actions"

import "./index.scss"
import { amountFormatter } from "helpers/util"
import { withWallet } from "helpers/with-wallet"

import { MANUAL_PAYMENT_MODES, APT_COIN_RATE } from "constants/config"

import HeroHeader from "components/hero-header/index"

const HTMLContainer = styled.div`
  text-align: justify;
  margin-bottom: 32px;

  p {
    font-size: 14px;
    color: #222;
    line-height: 1.5em;
  }
  label {
    font-weight: 400;
  }
  table {
    background-color: transparent;
    margin: 16px 0;

    tr td {
      border: 0;
      font-size: 14px;
      font-weight: 600;
      padding: 6px 12px;
    }
  }
  ol {
    list-style: decimal;
    li {
      margin-left: 32px;
    }
    li::marker {
      margin-top: 0;
    }
  }
`

class CoursePayment extends Component {
  constructor() {
    super()
    this.state = {
      modeOfPayment: "",
      paymentProcessor: "",
      magpieCheckout: null,
      magpieError: false,
      voucherCode: null,
      compliancePeriod: null,
      appliedCoins: 0,
      isApplyingCoins: false,
    }
  }

  componentDidMount() {
    const {
      location: { pathname },
      fetchCourseById,
      getWalletBalance,
      getWalletTransactions,
      getPaymentChannels,
    } = this.props

    let currentPath = pathname.split("/")
    let courseId = false
    if (
      currentPath[1] === "course" &&
      currentPath[2] === "payment" &&
      !isEmpty(currentPath[3])
    ) {
      courseId = currentPath[3].split(/[\s-]+/).pop()
      fetchCourseById(courseId)
      this.removeVoucher()
    }

    getWalletBalance()
    getWalletTransactions()
    getPaymentChannels({
      content_type: "course",
      object_id: courseId,
    })
    this.removeVoucher()
    this.removeCoins()
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname: prevPathname },
      // user: { walletDetails: prevWalletDetails = {} },
      courses: {
        isLoadingVoucher: prevIsLoadingVoucher,
        isLoadingAptCoins: prevIsLoadingAptCoins,
      },
    } = prevProps

    const {
      location: { pathname },
      // user: { walletDetails = {} },
      courses: {
        voucherDetails,
        isLoadingVoucher,
        coinsDiscountDetails,
        isLoadingAptCoins,
      },
      // wallet,
      fetchCourseById,
      getPaymentChannels,
    } = this.props
    const { modeOfPayment } = this.state

    // const { walletAddress } = wallet
    // const prevUserNonce = prevWalletDetails?.nonce
    // const userNonce = walletDetails?.nonce

    if (pathname !== prevPathname) {
      let currentPath = pathname.split("/")
      if (
        currentPath[1] === "course" &&
        currentPath[2] === "payment" &&
        !isEmpty(currentPath[3])
      ) {
        let id = currentPath[3].split(/[\s-]+/).pop()
        fetchCourseById(id)
        getPaymentChannels()
      }
    }

    if (
      coinsDiscountDetails?.success &&
      !isLoadingAptCoins &&
      isLoadingAptCoins !== prevIsLoadingAptCoins
    ) {
      const { paymentWaived, appliedCoins, fee } = this.calculateAmount()

      let newModeOfPayment = modeOfPayment
      if (paymentWaived) {
        if (appliedCoins === fee) {
          newModeOfPayment = "coins"
        } else {
          newModeOfPayment = "voucher"
        }
      }

      this.setState({
        appliedCoins: appliedCoins,
        modeOfPayment: newModeOfPayment,
        paymentWaived,
      })
    }

    if (
      voucherDetails?.coupon &&
      !isLoadingVoucher &&
      isLoadingVoucher !== prevIsLoadingVoucher
    ) {
      const { appliedCoins, fullDiscount, paymentWaived } =
        this.calculateAmount()

      if (fullDiscount || appliedCoins === 0) {
        this.removeCoins()
      }

      this.setState({
        appliedCoins: appliedCoins,
        modeOfPayment: paymentWaived ? "voucher" : modeOfPayment,
        paymentWaived,
      })
    }

    // if (wallet?.web3 && userNonce && prevUserNonce !== userNonce) {
    //   const signingMessage = this.getSigningMessage(walletAddress)

    //   wallet.web3.eth.personal.sign(
    //     wallet.web3.utils.fromUtf8(signingMessage),
    //     walletAddress,
    //     (err, signature) => {
    //       if (err) {
    //         this.handleSigningFailed(err)
    //       } else {
    //         this.handleSigningDone(walletAddress, signature)
    //       }
    //     }
    //   )
    // }
  }

  getSigningMessage = (walletAddress) => {
    const {
      user: { walletDetails = {} },
    } = this.props
    const userNonce = walletDetails?.nonce

    return `I am ${walletAddress}, signing my one-time nonce: ${userNonce}`
  }

  handleSigningDone = (address, signature) => {
    const { appliedCoins, isApplyingCoins } = this.state
    const {
      courses: { selectedCourse },
      applyCourseAptCoins,
      verifyWalletAddress,
    } = this.props

    const payload = {
      public_address: address,
      message: this.getSigningMessage(address),
      signature,
    }
    if (isApplyingCoins) {
      applyCourseAptCoins(selectedCourse?.id, {
        coins: appliedCoins,
        ...payload,
      })
    } else {
      verifyWalletAddress(payload)
    }

    this.setState({ isApplyingCoins: false })
  }

  handleSigningFailed = (err) => {
    const { appliedCoins } = this.state
    const { wallet = {} } = this.props

    console.error("Message signing failed: ", err)
    toast.error("Message signature failed")

    if (appliedCoins) {
      this.setState({ isApplyingCoins: false })
    } else {
      wallet.logoutOfWeb3Modal()
    }
  }

  calculateDiscount = (coupon, coins = 0) => {
    const {
      courses: { selectedCourse },
    } = this.props

    let totalFee = selectedCourse?.subtotal + selectedCourse?.tax
    let discount = 0
    let fullDiscount = false

    if (coins) {
      totalFee -= coins
    }

    if (coupon) {
      if (coupon?.type === "Percentage discount") {
        discount = (selectedCourse?.fee * coupon?.value) / 100

        if (coupon?.value === 100 || totalFee <= discount) {
          fullDiscount = true
        }
      } else {
        if (totalFee <= coupon?.value) {
          discount = totalFee
          fullDiscount = true
        } else {
          discount = coupon?.value
        }
      }
    }

    return { discount, fullDiscount }
  }

  calculateAmount = () => {
    const {
      courses: {
        selectedCourse,
        voucherDetails = {},
        coinsDiscountDetails = {},
        paymentFees,
      },
      location: { search },
    } = this.props
    const { appliedCoins } = this.state

    const coinsSuccess = coinsDiscountDetails
      ? coinsDiscountDetails?.success
      : false

    const { discount, fullDiscount } = this.calculateDiscount(
      voucherDetails?.coupon,
      coinsDiscountDetails?.coins
    )

    const coinRate = APT_COIN_RATE
    let fee = selectedCourse?.fee
    let tax = selectedCourse?.tax
    let subtotal = selectedCourse?.subtotal
    let paymentWaived = false
    let gatewayFee = 0
    let validCoins = 0
    let appliedFiat = appliedCoins * coinRate

    if (!fullDiscount) {
      let totalFee = selectedCourse?.subtotal + selectedCourse?.tax - discount

      if (coinsSuccess) {
        if (totalFee - appliedFiat >= 0) {
          totalFee -= appliedFiat
          validCoins = appliedCoins
        } else {
          const excessCoins = ((totalFee - appliedFiat) / coinRate) * -1

          validCoins = appliedCoins - excessCoins
          totalFee = 0
        }
      }

      if (totalFee <= 0) {
        paymentWaived = true
      }

      if (!paymentWaived) {
        gatewayFee = paymentFees?.total_fee || 0
      }
    }

    const urlParams = new URLSearchParams(search)
    const classId = urlParams.get("class")
    let selectedClass = selectedCourse?.classes?.find(
      ({ id }) => id === parseInt(classId)
    )

    if (classId && selectedClass) {
      fee = selectedClass?.fee
      tax = selectedClass?.tax
      subtotal = selectedClass?.subtotal
    } else {
      fee = selectedCourse?.fee
      tax = selectedCourse?.tax
      subtotal = selectedCourse?.subtotal
    }

    appliedFiat = validCoins * coinRate
    let netTotal = subtotal + tax + gatewayFee - discount - appliedFiat

    return {
      fee,
      tax,
      subtotal,
      gatewayFee,
      discount,
      fullDiscount,
      netTotal,
      coinRate,
      paymentWaived: netTotal <= 0,
      appliedCoins: appliedFiat,
    }
  }

  handleSelectModeOfPayment = (e) => {
    const { value } = e.currentTarget

    if (MANUAL_PAYMENT_MODES.includes(value)) {
      this.removeCoins()
    }
    this.setState({ modeOfPayment: value, paymentProcessor: "" }, () => {
      if (value !== "cash") {
        this.handleGetPaymentfees()
      }
    })
  }

  handleGetPaymentfees = () => {
    const {
      courses: { selectedCourse, paymentChannels },
      getPaymentFees,
    } = this.props

    const { appliedCoins, voucherCode, paymentProcessor, modeOfPayment } =
      this.state
    let gateway =
      paymentChannels?.[modeOfPayment]?.find(
        (code) => code?.value === paymentProcessor
      )?.gateway || ""

    let paymentChannelCode = paymentProcessor
    if (modeOfPayment === "cash") {
      gateway = "cash"
    } else if (modeOfPayment === "card") {
      gateway = "magpie"
      paymentChannelCode = "card"
    }

    const payload = {
      channel_code: paymentChannelCode,
      gateway: gateway,
      object_id: selectedCourse?.id,
      content_type: "course",
      voucher_code: voucherCode,
      coins: parseFloat(appliedCoins),
    }
    getPaymentFees(payload)
  }

  handleSelectPaymentChannel = (e) => {
    const { value } = e.currentTarget
    this.setState(
      {
        paymentProcessor: value,
      },
      () => {
        this.handleGetPaymentfees()
      }
    )
  }

  onSubmitPaymentMethod = () => {
    const { postPayment } = this.props
    let data = this.getPaymentPayload()
    postPayment(data)
  }

  getPaymentPayload = () => {
    const { modeOfPayment, voucherCode, compliancePeriod, paymentProcessor } =
      this.state
    const {
      courses: {
        selectedCourse,
        voucherDetails,
        coinsDiscountDetails,
        paymentChannels,
      },
      school: { schoolData },
      location: { search },
    } = this.props
    const { config: schoolConfig = {} } = schoolData

    const coinsSuccess = coinsDiscountDetails
      ? coinsDiscountDetails?.success
      : false

    const voucherSuccess = voucherDetails ? voucherDetails?.success : false
    const { appliedCoins, fullDiscount } = this.calculateAmount()

    const gateway =
      paymentChannels?.[modeOfPayment]?.find(
        (code) => code?.value === paymentProcessor
      )?.gateway || ""
    let data = {
      content_type: "course",
    }

    let classId = search.split(/[\s=]+/).pop()
    if (classId) {
      data.object_id = parseInt(classId) // ?
      data.content_type = "class"
    } else {
      data.object_id = selectedCourse?.id
    }

    if (schoolConfig?.products?.mcle) {
      data.compliance_period = compliancePeriod
    }

    if (voucherSuccess) {
      data.voucher_code = voucherCode

      if (fullDiscount) {
        return data
      }
    }

    if (coinsSuccess && appliedCoins > 0) {
      data.coins = appliedCoins

      if (fullDiscount) {
        return data
      }
    }

    data = {
      ...data,
      channel_code:
        modeOfPayment === "cash"
          ? "cash"
          : modeOfPayment === "card"
          ? "card"
          : paymentProcessor,
      gateway:
        modeOfPayment === "cash"
          ? "cash"
          : modeOfPayment === "card"
          ? "magpie"
          : gateway,
      processor_type: modeOfPayment,
    }

    return data
  }

  handleChange = (e) => {
    const { name, value } = e.currentTarget

    this.setState({
      [name]: value,
    })
  }

  handleSelect = (data) => {
    const { name, value } = data

    this.setState({
      [name]: value,
    })
  }

  applyVoucher = () => {
    const { voucherCode } = this.state
    const {
      courses: { selectedCourse },
      fetchCourseVoucher,
    } = this.props

    if (voucherCode) {
      fetchCourseVoucher(voucherCode, selectedCourse?.id)
    }

    this.handleGetPaymentfees()
  }

  removeVoucher = () => {
    const { removeVoucher } = this.props

    this.setState({ voucherCode: "", paymentWaived: false }, () => {
      this.handleGetPaymentfees()
    })

    removeVoucher()
  }

  applyCoins = (walletBalance = 0) => {
    const { appliedCoins } = this.state
    const {
      courses: { selectedCourse },
      applyCourseAptCoins,
    } = this.props
    // const { getUserWalletNonce, wallet } = this.props

    if (appliedCoins && appliedCoins > 0) {
      if (appliedCoins > walletBalance) {
        this.setState({ appliedCoins: walletBalance })
      }
      // this.setState({ isApplyingCoins: true })
      // getUserWalletNonce({ public_address: walletAddress })

      applyCourseAptCoins(selectedCourse?.id, {
        coins: parseFloat(appliedCoins),
        // address: wallet.walletAddress
      })

      this.handleGetPaymentfees()
    }
  }

  removeCoins = () => {
    const { removeCoins } = this.props
    const { appliedCoins } = this.state

    if (appliedCoins > 0) {
      this.setState({ appliedCoins: 0, paymentWaived: false }, () => {
        this.handleGetPaymentfees()
      })
    }

    removeCoins()
  }

  render() {
    const {
      school: { schoolData },
      courses: {
        selectedCourse,
        isLoadingSelectedCourse,
        voucherDetails,
        isLoadingVoucher,
        coinsDiscountDetails,
        paymentChannels,
        isLoadingAptCoins,
        isLoading,
        isLoadingPaymentChannels,
      },
      user: {
        processingPayment,
        walletDetails = {},
        compliancePeriod: compliancePeriodOptions,
      },
      // wallet,
    } = this.props
    const { config: schoolConfig = {}, name: schoolName } = schoolData
    const { config: courseConfig = {} } = selectedCourse
    const { mode_of_payment = [] } = courseConfig
    const { balance: walletBalance } = walletDetails || {}
    // const { walletBalance, isWalletConnected, loadWeb3Modal } = wallet

    const {
      modeOfPayment,
      paymentProcessor,
      magpieError,
      voucherCode,
      compliancePeriod,
      appliedCoins,
      isApplyingCoins,
    } = this.state

    const isComplianceRequired = schoolConfig?.products?.mcle
    const voucherSuccess = voucherDetails ? voucherDetails?.success : false
    const coinsSuccess = coinsDiscountDetails
      ? coinsDiscountDetails?.success
      : false

    const coinsAllowed = !MANUAL_PAYMENT_MODES.includes(modeOfPayment)

    const {
      tax,
      subtotal,
      gatewayFee,
      discount,
      netTotal,
      paymentWaived,
      appliedCoins: validCoins,
    } = this.calculateAmount()

    const routeList = {
      "/": "Home",
      "/courses": "Course",
      "/Payment": "Payment",
    }

    return (
      <PageContainer isPageLoading={isLoadingSelectedCourse}>
        <HeroHeader
          title="Course Payment"
          description=""
          routeList={routeList}
          activeColor={schoolData.primary_color}
          activeItem="Payment"
        />
        <div className="page-wrapper -payment">
          <div className="payment-body">
            <div className="computation-summary">
              <div className="course-item">
                <div className="course-thumbnail">
                  <img src={selectedCourse.image} alt="" />
                </div>
                <div className="course-details">
                  <p className="course-name">{selectedCourse.name}</p>
                  <p className="course-description">
                    {selectedCourse.description}
                  </p>
                </div>
              </div>
              {isComplianceRequired &&
                selectedCourse?.enrollment?.status !== "pay_later" && (
                  <div className="compliance-container">
                    <p>Select Compliance Period</p>
                    <FormDropdown
                      horizontal
                      name="compliancePeriod"
                      handleChange={this.handleSelect}
                      options={compliancePeriodOptions}
                      value={compliancePeriod}
                      required={true}
                    />
                  </div>
                )}
              <p>Modes of Payment</p>
              {isLoadingPaymentChannels ? (
                <Spinner isFetching={isLoadingPaymentChannels} />
              ) : (
                <div className="radio-group">
                  {mode_of_payment.includes("cash") && (
                    <>
                      <FormRadio
                        id="cash"
                        name="selectedModeOfPayment"
                        value="cash"
                        onChange={this.handleSelectModeOfPayment}
                        text={`Pay Directly to ${schoolName}`}
                        disabled={paymentWaived}
                      />
                      <label className="radio-desc">
                        Pay directly at the admin office.
                      </label>
                      {schoolData?.payment_instructions &&
                        modeOfPayment === "cash" && (
                          <HTMLContainer>
                            {parse(schoolData?.payment_instructions)}
                          </HTMLContainer>
                        )}
                    </>
                  )}

                  {mode_of_payment.includes("online_bank") &&
                    paymentChannels?.online_bank?.length > 0 && (
                      <Fragment>
                        <FormRadio
                          id="online_bank"
                          name="selectedModeOfPayment"
                          value="online_bank"
                          onChange={this.handleSelectModeOfPayment}
                          text="Online Banking"
                          disabled={paymentWaived}
                        />
                        <label className="radio-desc">
                          Pay online by logging into your preferred bank's
                          mobile or web application.
                        </label>

                        {modeOfPayment === "online_bank" && (
                          <div
                            className="select-wrapper"
                            id="online_bank_processor"
                          >
                            <select
                              name="online_bank_processor"
                              className="select"
                              onChange={this.handleSelectPaymentChannel}
                              value={paymentProcessor}
                              disabled={paymentWaived}
                            >
                              {paymentProcessor ? (
                                ""
                              ) : (
                                <option value={null} key={-1}>
                                  Select ...
                                </option>
                              )}

                              {paymentChannels?.online_bank?.map(
                                (item, index) => (
                                  <option
                                    value={item?.value}
                                    key={index}
                                    datagateway={item?.gateway}
                                  >
                                    {item?.name}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        )}
                      </Fragment>
                    )}
                  {mode_of_payment.includes("otc_bank") &&
                    paymentChannels?.otc_bank?.length > 0 && (
                      <>
                        <FormRadio
                          id="otc_bank"
                          name="selectedModeOfPayment"
                          value="otc_bank"
                          onChange={this.handleSelectModeOfPayment}
                          text="Over-the-Counter Banking"
                          disabled={paymentWaived}
                        />
                        <label className="radio-desc">
                          Go to the nearest branch of any of our supported banks
                          to make a deposit payment over-the-counter.
                        </label>
                        {modeOfPayment === "otc_bank" && (
                          <div
                            className="select-wrapper"
                            id="otc_bank_processor"
                          >
                            <select
                              name="otc_bank_processor"
                              className="select"
                              onChange={this.handleSelectPaymentChannel}
                              value={paymentProcessor}
                              disabled={paymentWaived}
                            >
                              {paymentProcessor ? (
                                ""
                              ) : (
                                <option value={null} key={-1}>
                                  Select ...
                                </option>
                              )}

                              {paymentChannels?.otc_bank?.map((item, index) => (
                                <option
                                  value={item?.value}
                                  key={index}
                                  datagateway={item?.gateway}
                                >
                                  {item?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </>
                    )}

                  {mode_of_payment.includes("otc_nonbank") &&
                    paymentChannels?.otc_nonbank?.length > 0 && (
                      <>
                        <FormRadio
                          id="otc_nonbank"
                          name="selectedModeOfPayment"
                          value="otc_nonbank"
                          onChange={this.handleSelectModeOfPayment}
                          text="Over-the-Counter Non-Banks"
                          disabled={paymentWaived}
                        />
                        <label className="radio-desc">
                          Walk-in to any branch of our partners to make a
                          payment over-the-counter.
                        </label>
                        {modeOfPayment === "otc_nonbank" && (
                          <div className="select-wrapper" id="others_processor">
                            <select
                              name="others_processor"
                              className="select"
                              onChange={this.handleSelectPaymentChannel}
                              value={paymentProcessor}
                              disabled={paymentWaived}
                            >
                              {paymentProcessor ? (
                                ""
                              ) : (
                                <option value={null} key={-1}>
                                  Select ...
                                </option>
                              )}

                              {paymentChannels?.otc_nonbank?.map(
                                (item, index) => (
                                  <option
                                    value={item?.value}
                                    key={index}
                                    datagateway={item?.gateway}
                                  >
                                    {item?.name}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        )}
                      </>
                    )}
                  {mode_of_payment.includes("card") && !magpieError && (
                    <>
                      <FormRadio
                        id="card"
                        name="selectedModeOfPayment"
                        value="card"
                        onChange={this.handleSelectModeOfPayment}
                        text="Mastercard/Visa Card"
                        disabled={paymentWaived}
                      />
                      <label className="radio-desc">
                        Pay online using any card with a Visa or Mastercard
                        logo, whether credit, debit or prepaid.
                      </label>
                    </>
                  )}
                  {mode_of_payment.includes("ewallet") &&
                    paymentChannels?.ewallet?.length > 0 && (
                      <>
                        <FormRadio
                          id="ewallet"
                          name="selectedModeOfPayment"
                          value="ewallet"
                          onChange={this.handleSelectModeOfPayment}
                          text="E-Wallet"
                          disabled={paymentWaived}
                        />
                        <label className="radio-desc">
                          Pay using your e-wallet
                        </label>
                        {modeOfPayment === "ewallet" && (
                          <div
                            className="select-wrapper"
                            id="otc_bank_processor"
                          >
                            <select
                              name="otc_bank_processor"
                              className="select"
                              onChange={this.handleSelectPaymentChannel}
                              value={paymentProcessor}
                              disabled={paymentWaived}
                            >
                              {paymentProcessor ? (
                                ""
                              ) : (
                                <option value={null} key={-1}>
                                  Select ...
                                </option>
                              )}

                              {paymentChannels?.ewallet?.map((item, index) => (
                                <option
                                  value={item?.value}
                                  key={index}
                                  datagateway={item?.gateway}
                                >
                                  {item?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </>
                    )}
                </div>
              )}

              <p>Voucher Code</p>
              <div className="payment-voucher">
                <FormInput
                  name="voucherCode"
                  value={voucherCode}
                  placeholder="Enter your voucher code"
                  handleChange={this.handleChange}
                  error={!voucherSuccess ? voucherDetails?.message : ""}
                  disabled={voucherSuccess || isLoadingVoucher || paymentWaived}
                  success={voucherSuccess}
                  labelFor={
                    voucherSuccess ? "Successfully applied voucher!" : ""
                  }
                />
                <Button
                  label={voucherSuccess ? "Remove Voucher" : "Apply Voucher"}
                  color={voucherSuccess ? "#f90037" : ""}
                  disabled={!voucherCode}
                  onClick={
                    voucherSuccess ? this.removeVoucher : this.applyVoucher
                  }
                />
              </div>
              <label className="help-text">
                Applicable only for those provided with voucher codes.
                Otherwise, please leave blank.
              </label>
              {coinsAllowed && (
                <>
                  <p>
                    Use L2E Coins{" "}
                    <span style={{ color: schoolData.primary_color }}>
                      (Available:{" "}
                      {/* {isWalletConnected ? amountFormatter(walletBalance) : "0.00"}  // For L2E wallet */}
                      {amountFormatter(walletBalance)})
                    </span>
                  </p>
                  {/* {isWalletConnected ? (  // For L2E wallet */}
                  <>
                    <div className="payment-aptcoins">
                      <FormInput
                        name="appliedCoins"
                        type="number"
                        value={appliedCoins}
                        placeholder="0.000"
                        min="0"
                        handleChange={this.handleChange}
                        error={
                          !coinsSuccess ? coinsDiscountDetails?.message : ""
                        }
                        disabled={
                          coinsSuccess ||
                          isLoadingAptCoins ||
                          paymentWaived ||
                          walletBalance <= 0 ||
                          isApplyingCoins
                        }
                        success={coinsSuccess}
                        labelFor={coinsSuccess ? "Successfully applied!" : ""}
                      />
                      <Button
                        label={coinsSuccess ? "Remove Coins" : "Apply Coins"}
                        color={coinsSuccess ? "#f90037" : ""}
                        disabled={
                          !appliedCoins || appliedCoins <= 0 || isApplyingCoins
                        }
                        onClick={
                          coinsSuccess
                            ? () => this.removeCoins()
                            : () => this.applyCoins(walletBalance)
                        }
                      />
                    </div>
                    <label className="help-text">
                      1 L2E = ₱ {amountFormatter(APT_COIN_RATE)}
                    </label>
                  </>
                  {/* ) : (
                    <Button label="Connect Wallet" onClick={loadWeb3Modal} />  // For L2E wallet
                  )} */}
                </>
              )}
            </div>
            <div className="course-breakdown">
              <p className="item">Subtotal</p>
              <p className="price">{`${amountFormatter(subtotal)}`}</p>
              <p className="item">Value-Added Tax</p>
              <p className="price">{`${amountFormatter(tax)}`}</p>
              <p className="item">Payment Gateway Fee</p>
              <p className="price">{amountFormatter(gatewayFee)}</p>
              <p className="item">Voucher Discount</p>
              <p className="price">{amountFormatter(-discount)}</p>
              {coinsAllowed && (
                <>
                  <p className="item">L2E Coins</p>
                  <p className="price">
                    {amountFormatter(coinsSuccess ? -validCoins : 0)}
                  </p>
                </>
              )}
              <p className="item -final">Total Payment</p>
              <p className="price -final">{`${amountFormatter(netTotal)}`}</p>
              <Button
                disabled={
                  isLoading ||
                  isEmpty(modeOfPayment) ||
                  ([
                    "online_bank",
                    "otc_bank",
                    "otc_nonbank",
                    "ewallet",
                  ].includes(modeOfPayment) &&
                    isEmpty(paymentProcessor)) ||
                  (isComplianceRequired &&
                    !compliancePeriod &&
                    selectedCourse?.enrollment?.status !== "pay_later")
                }
                label="Purchase Course"
                onClick={() => this.onSubmitPaymentMethod()}
                loading={processingPayment}
              />
            </div>
          </div>
          <Button
            outlined
            label="Go Back"
            onClick={() => history.push(`/course/${selectedCourse?.slug}`)}
          />
        </div>
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  courses: state.coursesReducer,
  user: state.userReducer,
  auth: state.authReducer,
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchCourseById,
      showResponseModal,
      closeResponseModal,
      fetchCourseVoucher,
      removeVoucher,
      getWalletBalance,
      getWalletTransactions,
      applyCourseAptCoins,
      removeCoins,
      verifyWalletAddress,
      getUserWalletNonce,
      getPaymentChannels,
      getPaymentFees,
      postPayment,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withWallet
)(CoursePayment)
